import { useCallback, } from 'react';
import { connect } from 'react-redux';

import { DELETE_PROJECT_SCHEDULE_CONTACT, SET_DELETE_CONTACT_DIALOGUE_OPEN } from '../actions/types';
import { siteboardAction, } from '../actions/defaultActions';
import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

const DeleteScheduleContactDialogue = ({ _projects, _deleteContactDialogueProjectId, _deleteContactDialogueEmail, _subscriptionContacts, siteboardAction }) => {
  const closeDialogue = useCallback(() => {
    siteboardAction(SET_DELETE_CONTACT_DIALOGUE_OPEN, { isOpen: false, projectId: '00000000-0000-0000-0000-000000000000', email: 'none@none' });
  }, [siteboardAction]);

  const selectedProject = _projects[_deleteContactDialogueProjectId];
  if(selectedProject === undefined) return (<></>);

  const selectedContact = (() => {
    try { return _subscriptionContacts[selectedProject.subscriptionId][_deleteContactDialogueEmail]; } 
    catch(error) { return undefined; }
  })();
  if(selectedContact === undefined) return (<></>);

  return (
    <PopupWindow title='Delete Contact' closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-[400px] bg-[#333] text-white'>
        <div className=''>
          Delete <b>{selectedContact.email}</b> as a contact for project <b>"{selectedProject.name}"</b>? 
        </div>
        <div className='flex mt-4'>
          <PushButton 
            textColor='white'
            bgColor='bg-red-800'
            hoverBgColor='bg-red-600'
            onClick={() => {
              const onSuccess = () => {
                siteboardAction(SET_DELETE_CONTACT_DIALOGUE_OPEN, { isOpen: false, projectId: '00000000-0000-0000-0000-000000000000', email: 'none@none' });
              };
              siteboardAction(DELETE_PROJECT_SCHEDULE_CONTACT, { projectId: selectedProject.id, contactEmail: selectedContact.email }, onSuccess);
            }}
          >
            Delete Contact
          </PushButton>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _deleteContactDialogueProjectId: state.localEphemeral.deleteContactDialogueProjectId,
  _deleteContactDialogueEmail: state.localEphemeral.deleteContactDialogueEmail,
  _subscriptionContacts: state.serverSynced.subscriptionContacts,
}};
export default connect(mapStateToProps, { siteboardAction })(DeleteScheduleContactDialogue);
